module.exports = __webpack_public_path__ + "static/img/bg_jrcz.321c235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/member/bg_jrcz.png
// module id = 6XvG
// module chunks = 2